import { theme } from 'theme'

import { SxProps } from '@mui/material'

const valueText: SxProps = {
  fontSize: 12,
  fontWeight: 400,
  display: 'inline',
}

const labelText: SxProps = {
  ...valueText,
  color: theme.palette.gray.main,
}

const Styles = {
  labelText,
  valueText,
}

export default Styles
